/**
 * @file 读 cooke
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/cookie
 */

import {areCookiesEnabled} from './detectStorageAvailability';

/**
 * 转义正则关键字字符
 *
 * @param {string} string 需要转义的字符
 * @return {string} 转义后的字符
 * @inner
 */
const escapeRegExp = string => String(string).replace(/([-.*+?^${}()|[\]/\\])/ug, '\\$1');
const CAN_I_USE_COOKIE = areCookiesEnabled();

export default {

    /**
     * 读取 Cookie 中指定键的值
     *
     * @param {string} key 要读取的 Cookie 键名
     * @param {string=} [cookie=document.cookie] 要读取的 Cookie
     * @return {string}
     */
    get(key, cookie = '') {
        if (!CAN_I_USE_COOKIE) {
            return '';
        }

        let cookieValue = cookie;
        if (typeof document !== 'undefined' && !cookieValue) {
            const {cookie} = document;
            cookieValue = cookie;
        }

        const value = cookieValue.match(
            `(?:^|;)\\s*${escapeRegExp(key)}=([^;]*)`
        );

        return value ? decodeURIComponent(value[1]) : '';
    },

    /**
     * 设置 Cookie 中指定键的值，实现方式参照 mdn 使用 cookie.set(key, value, options)
     *
     * @param {string} key 要读取的 Cookie 键名
     * @param {string} value 要设置的 Cookie 值
     * @param {Object} options 要设置的 Cookie 的配置信息
     * @return {boolean} cookie 设置是否成功
     */
    set(key = '', value = '', options = {}) {
        if (!CAN_I_USE_COOKIE) {
            return false;
        }

        const {end = '', path = '', domain = '', sameSite = 'Lax', secure = false} = options;

        if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) {
            return false;
        }

        let sExpires = '';
        if (end) {
            if (typeof end === 'number') {
                sExpires = end === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : `; max-age=${end}`;
            }
            else if (end instanceof Date) {
                sExpires = `; expires=${end.toUTCString()}`;
            }
            else {
                sExpires = `; expires=${end}`;
            }
        }

        const sKeyValue = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        const sDomain = domain ? `; domain=${domain}` : '';
        const sPath = path ? `; path=${path}` : '';
        const sSameSite = `; SameSite=${sameSite}`;
        const sSecure = secure ? '; Secure' : '';

        document.cookie = `${sKeyValue}${sExpires}${sDomain}${sPath}${sSameSite}${sSecure}`;
        return true;
    },
};
